import React from 'react';
import messages from '../../common/utils/messages';
import { ItemWithAvatarGroup, SectionContainer } from '../../ui/primitives';
import { type JoinableSiteItemType } from '../utils/cross-join-links';
import { AnalyticsItemType } from '../../types';
import { getItemAnalyticsContext, NavigationAnalyticsContext } from '../../common/utils/analytics';
import { FormattedMessage } from 'react-intl-next';
import { useExperienceSuccess, Experience } from '../../common/utils/experience-tracker';
import { AppIcon } from '../../ui/primitives/app-icon';

interface CrossJoinSectionProps {
	joinableSiteLinks?: JoinableSiteItemType[];
	onClose?: () => void;
}

export const CrossJoinSection = (props: CrossJoinSectionProps) => {
	const { joinableSiteLinks = [], onClose } = props;

	useExperienceSuccess(Experience.RENDER_JOIN_SECTION);

	return (
		<SectionContainer sectionId="join" title={<FormattedMessage {...messages.join} />}>
			{joinableSiteLinks.map(
				(
					{ cloudId, description, href, iconKey, label, productType, users },
					groupIndex: number,
				) => (
					<NavigationAnalyticsContext
						key={groupIndex}
						data={getItemAnalyticsContext(groupIndex, cloudId, AnalyticsItemType.JOIN, productType)}
					>
						<ItemWithAvatarGroup
							icon={<AppIcon iconKey={iconKey} />}
							description={description}
							users={users}
							href={href}
							onItemClick={() => {
								onClose && onClose();
							}}
							target="_blank"
							rel="noreferrer"
						>
							{label}
						</ItemWithAvatarGroup>
					</NavigationAnalyticsContext>
				),
			)}
		</SectionContainer>
	);
};
